// type 为前端约定的角色类型，后续接口可使用同一字段区分角色来源。
export const ROLE_CONFIG = {
    branch: { list: 'branchList', module: 'zzjs', label: '支部', flag: 2, path: '/workspace/demonstrate' },
    branchManager: { list: 'branchManagerList', module: 'zzjs', label: '支部管理员', flag: 2, path: '/workspace/list', manager: true },
    home: { list: 'homeList', module: 'sxzzjs', label: '党员之家', flag: 1, path: '/workspace/party-info' },
    homeManager: { list: 'homeManagerList', module: 'sxzzjs', label: '党员之家管理员', flag: 1, path: '/workspace/party-list', manager: true }
}

export const getRoleKey = role => JSON.stringify([role.type, String(role.id)])

export const getRoleName = role => (role && (role.name || role.orgName)) || ''

export const isCentralRole = role => !!(role && ROLE_CONFIG[role.type] &&
    ROLE_CONFIG[role.type].manager && Number(role.orgType) === 1)

// 中央账号按接口返回的全部管理员身份判断，不随当前选中的身份变化。
export const isCentralAccount = roles => Array.isArray(roles) && roles.some(isCentralRole)

export const getRolesForModule = (roles, module) => {
    const availableRoles = Array.isArray(roles) ? roles : []
    const moduleRoles = availableRoles.filter(role => {
        const config = ROLE_CONFIG[role.type]
        return config && config.module === module
    })
    // 缺少目标模块身份时，中央管理员可沿用真实身份进入两个建设模块。
    if (['zzjs', 'sxzzjs'].includes(module) && !moduleRoles.length) {
        return availableRoles.filter(isCentralRole)
    }
    return moduleRoles
}

export const createUserRoles = (data = {}) => {
    return Object.keys(ROLE_CONFIG).reduce((roles, type) => {
        const config = ROLE_CONFIG[type]
        const list = Array.isArray(data[config.list]) ? data[config.list] : []
        return roles.concat(list.filter(item => item && item.id != null && item.id !== '').map(item => ({
            id: item.id,
            name: getRoleName(item),
            type,
            // 兼容现有页面和接口读取的机构信息；角色标识统一使用 id/name/type。
            orgName: getRoleName(item),
            targetUsername: item.orgUid,
            orgType: item.orgType,
            provinceId: item.provinceId,
            cityId: item.cityId,
            countryId: item.countryId,
            flag: config.flag,
            // id 是角色标识；uid 是支部/党员之家的业务标识，不能互相替代。
            uid: config.manager ? undefined : item.uid
        })))
    }, [])
}
